import React, { useState } from "react";
import { useIntl } from "react-intl";
import {
  Grid,
  Box,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  CircularProgress,
} from "@material-ui/core";
import translate from "i18n/translate";
import { SrCurrency, Typography, SrCardsLogos } from "components/common";
import Detail from "./ResumeDetail/Detail";
import { useStyles } from "../tableStyles";

const TransactionsTable = ({
  transactions,
  loading,
  paginationConfig,
  updateTransactions,
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const [showDetail, setShowDetail] = useState(false);
  const [selectedItem, setSelectedItem] = useState();

  const sellChannels = {
    POS: intl.formatMessage({ id: "common.card" }),
    E: intl.formatMessage({ id: "common.ecommerce" }),
    R: intl.formatMessage({ id: "common.recurrent" }),
  };

  const hadleCloseDetail = () => {
    setShowDetail(false);
  };

  const handleOpenDetail = (transaction) => {
    setSelectedItem(transaction);
    setShowDetail(true);
  };

  const handleRelatedClick = (key) => {
    const { rows } = transactions;
    setShowDetail(false);

    // delay to show the user that the transaction has changed
    setTimeout(() => {
      if (rows) {
        const relatedTransaction = rows.find(
          (transaction) => transaction.key === key
        );

        setSelectedItem(relatedTransaction);
        setShowDetail(true);
      }
    }, 500);
  };

  if (loading) {
    return (
      <Box display="flex">
        <CircularProgress />
      </Box>
    );
  }

  const totalClassName = (total, hasDevolution) =>
    total < 0 && !hasDevolution ? classes.negativeValue : undefined;

  return transactions?.rows?.length ? (
    <>
      {selectedItem && (
        <Detail
          isOpen={showDetail}
          transaction={selectedItem}
          onClose={hadleCloseDetail}
          onRelatedClick={handleRelatedClick}
          updateTransactions={updateTransactions}
        />
      )}
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell align="left">
                {translate("resume.transactions.date")}
              </TableCell>
              <TableCell align="left">
                {translate("resume.transactions.paymentMethod")}
              </TableCell>
              <TableCell align="left">
                {translate("resume.transactions.name")}
              </TableCell>
              <TableCell align="left">
                {translate("resume.transactions.concept")}
              </TableCell>
              <TableCell align="left">
                {translate("resume.transactions.sellChannel")}
              </TableCell>
              <TableCell align="right">
                {translate("resume.transactions.total")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {transactions.rows.map((row) => (
              <TableRow
                className={classes.selectable}
                key={row.key}
                onClick={() => handleOpenDetail(row)}
                hover
              >
                <TableCell align="left">{row.date}</TableCell>
                <TableCell align="left">
                  {row.paymentMethod.cardID && (
                    <>
                      <SrCardsLogos imageKey={row.paymentMethod.cardID} />
                      <Box
                        fontWeight="fontWeightBold"
                        component="span"
                        marginLeft={1}
                      >
                        •••• {row.paymentMethod.cardNumber}
                      </Box>
                    </>
                  )}
                </TableCell>
                <TableCell align="left">{row.cardHolderName}</TableCell>
                <TableCell align="left">{row.concept}</TableCell>
                <TableCell align="left">
                  {sellChannels[row.sellChannel] || row.sellChannel}
                </TableCell>
                <TableCell align="right">
                  <Typography variant="caption">
                    {row.hasDevolution
                      ? `${intl.formatMessage({
                          id: "resume.transactions.cancelled",
                        })}: `
                      : ""}
                  </Typography>
                  <span
                    className={totalClassName(row.total, row.hasDevolution)}
                  >
                    <SrCurrency
                      value={row.hasDevolution ? -row.total : row.total}
                      currency={row.currency}
                    />
                  </span>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        {paginationConfig && (
          <TablePagination
            rowsPerPageOptions={paginationConfig.rowsPerPageOptions}
            component="div"
            count={paginationConfig.total}
            rowsPerPage={paginationConfig.limit}
            labelRowsPerPage={translate("common.rowsPerPage")}
            page={paginationConfig.page}
            onPageChange={paginationConfig.onPageChange}
            onRowsPerPageChange={paginationConfig.onRowsPerPageChange}
          />
        )}
      </TableContainer>
    </>
  ) : (
    <Grid container item justifyContent="center">
      {/* TODO: move to component */}
      <Box mb={12} mt={4} mx={4}>
        <Typography variant="h4Regular" align="left">
          {translate("resume.noTansactionsToShow")}
        </Typography>
      </Box>
    </Grid>
  );
};

export default TransactionsTable;
